import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(
  () => ({
    footer: {
      width: '100%',
      height: '5%',
      minHeight: '57px',
      background: '#FFF',
      position: 'fixed',
      bottom: '0',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    enphaselogo: {
      height: '26px',
      width: '130px',
      margin: '0 40px 0 41px',
    },
    anchorlink: { color: '#026AE3', textDecoration: 'none' },
    text: {
      fontFamily: 'Helvetica Neue',
      color: '#6F6F6F',
      fontSize: '14px',
    },
  }),
  { index: 1 },
)

export { useStyles }
